import { Radio, RadioGroup, FormControlLabel } from "@mui/material";

export default function ({
  name,
  items = [],
  value,
  handleChange,
  direction = "horizontal",
}) {
  return (
    <RadioGroup
      className="radio-group"
      aria-labelledby={`${name}-radio-buttons-group-label`}
      name={name}
      value={value}
      onChange={handleChange}
      row={direction === "horizontal"}
    >
      {items?.map((item) => (
        <FormControlLabel
          key={item.id}
          value={item.id}
          control={<Radio size="small" />}
          label={item.text}
        />
      ))}
    </RadioGroup>
  );
}
